import React, { useEffect, useState } from "react";
import { Suspense } from "react";
import TCnew from "../../Components/Certificates/TCnew";
import SelectSearch from "react-select-search";
import { MultiSelect } from "chakra-multiselect";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  ButtonGroup,
  Flex,
  Grid,
  GridItem,
  Input,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  VisuallyHidden,
  Tooltip,
  Spinner,
  Select,
  Checkbox,
  Badge,
} from "@chakra-ui/react";
import { FiUpload } from "react-icons/fi";
import { FileIcon, RemoveIcon } from "../../assets/svgs/Icons";
import { useDispatch, useSelector } from "react-redux";
import { DocumentViewer } from "../../Components/common/DocumentViewer";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import {
  acceptIncomingTC,
  getTCDetails,
  rejectIncomingTC,
} from "./TransactionCertificateSlice";
import moment from "moment/moment";
import {
  getCompanyData,
  getCompanyUnit,
  updateTcForm,
  getInventory,
  getOneInventoryDetails,
} from "../../api";
import { toast } from "react-toastify";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import isAllowed from "../../routing/isAllowed";
import DOCUMENT_FROM from "../../Common/Constants";
import { checkFileTypesAndSize } from "../../Common/utils";
import CustomAlertDialog from "../../Components/CustomAlertDialog";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  getCompanies,
  getCompanyDetails,
} from "../../redux/company/CompanySlice";

const ClientTCDetails = () => {
  const { TC, isloading } = useSelector(
    (state) => state.transactionCertificateClient
  );
  const editable = localStorage.getItem("activeTab");
  const [checkedItems, setCheckedItems] = useState(() => {
    if (TC?.tc_buyer?._id) {
      return [false, true];
    } else {
      return [true, false];
    }
  });
  const [selectedProcesses, setSelectedProcesses] = useState([]);
  const { userData } = useSelector((state) => state.auth);
  const [errorMessage, setErrorMessage] = useState("");
  const [products, setProducts] = useState([]);
  const [totalGrossWeight, setTotalGrossWeigth] = useState(0);
  const [totalCertifiedWeight, setTotalCertifiedWeigth] = useState(0);
  const [totalNetWeight, setTotalNetWeigth] = useState(0);
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [remarks, setRemarks] = useState([]);
  const [transportFile, setTransportFile] = useState(null);
  const [documentFile, setDocumentFile] = useState(null);
  const [isOpenMod, setIsOpenMod] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [processValues, setProcessValues] = useState([]);
  const [tcData, setTcData] = useState(TC || {});
  const onClose = () => setIsOpen(false);
  const onCloseMod = () => setIsOpenMod(false);
  const { id } = useParams();
  const [status, setStatus] = useState("idle");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { companyDetails } = useSelector((state) => state.company);
  const { allCompanies } = useSelector((state) => state.company);
  const [buyers, setBuyers] = useState([]);
  const [buyerId, setBuyerId] = useState("");
  const [consigneeUnits, setConsigneeUnits] = useState("");
  const [buyerCompany, setBuyerCompany] = useState([]);
  const [consigneeId, setConsigneeId] = useState("");
  const [consignee, setConsignee] = useState({});
  const [lastProcessorId, setLastProcessorId] = useState("");
  const [lastProcessor, setLastProcessor] = useState({});
  const [companyInventories, setCompanyInventories] = useState([]);
  const [unitId, setUnitId] = useState("");
  const [programId, setProgramId] = useState("");
  const [processes, setProcesses] = useState([]);
  const [inventoryId, setInventoryId] = useState("");
  const [inventoryDetails, setInventoryDetails] = useState({});

  const setInitialProductValues = () => {
    if (tcData?.products) {
      let INITIAL_PRODUCT_ARRAY = tcData?.products?.map((product, index) => {
        return {
          productId: product?.productId?._id,
          productName: product?.productId?.name,
          productType: product?.productId?.productType,
          productCategoryName:
            product?.productId?.product_productCategory?.name,
          productCategory: product?.productId?.product_productCategory?._id,
          productClassificationName:
            product?.productId?.product_productClassification?.name,
          productClassification:
            product?.productId?.product_productClassification?._id,
          invoiceNo: product?.invoiceNo,
          invoiceDate: product?.invoiceDate,
          process: product?.process,
          sequenceNumber: product?.sequenceNumber,
          netWeight: product?.netWeight,
          grossWeight: product?.grossWeight,
          certifiedMaterial: {
            commodityId: product?.certifiedMaterial?.commodityId?._id,
            percentage: product?.certifiedMaterial?.percentage,
            lossPercent: product?.certifiedMaterial?.lossPercent,
            certifiedWeight: product?.certifiedMaterial?.certifiedWeight,
            consumption: product?.certifiedMaterial?.consumption,
          },
          certifiedMaterialName: product?.certifiedMaterial?.commodityId?.name,
          productInformation: product?.productInformation,
          nonCertifiedMaterials: product?.nonCertifiedMaterials?.map(
            (material) => {
              return {
                commodityId: material.commodityId?._id,
                nonCertifiedMaterialName: material.commodityId?.name,
                consumption: material?.consumption,
                lossPercent: material?.lossPercent,
                nonCertifiedWeight: material?.nonCertifiedWeight,
                percentage: material?.percentage,
              };
            }
          ),
          inputs: product?.inputs?.map((input) => {
            return {
              productClassification: input?.productClassification,
              availableQuantity: input?.availableQuantity,
              inventoryDetails: input?.inventoryDetails?._id,
              consumedQuantity: input?.consumedQuantity,
              procurementId: input?.procurementId?._id,
              inventoryName: input?.inventoryDetails?.id,
            };
          }),
        };
      });
      setProducts(INITIAL_PRODUCT_ARRAY);
    }
  };

  const handleCheckboxChange = (index) => {
    setCheckedItems((prevState) => {
      const updatedState = [...prevState];
      updatedState[index] = !updatedState[index];
      updatedState[1 - index] = false;
      return updatedState;
    });
  };

  const getCompany = () => {
    try {
      const result = dispatch(getCompanyDetails(userData?.companyId));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getBuyersData = async () => {
    let buyerOPtions = allCompanies?.data?.map((buyer) => {
      return {
        name: `${buyer?.name} (${buyer.license})`,
        value: buyer?._id,
      };
    });
    setBuyers(buyerOPtions);
  };

  const getBuyersCompanyUnit = async () => {
    const response = await getCompanyUnit(consigneeId);
    setConsignee(response?.data);
  };

  const getInventoryDetails = async () => {
    const response = await getOneInventoryDetails(inventoryId);
    setInventoryDetails(response?.data);
  };

  const getSellersCompanyUnit = async () => {
    const response = await getCompanyUnit(lastProcessorId);
    setLastProcessor(response?.data);
  };

  const getBuyersCompany = async () => {
    const response = await getCompanyData(buyerId && buyerId);
    let buyerOPtions = response?.data?.company_units?.map((unit) => {
      return {
        name: `${unit?.name}`,
        value: unit?._id,
      };
    });
    setBuyerCompany(response?.data);
    setConsigneeUnits(buyerOPtions);
  };

  const getAllCompanies = async () => {
    let programId = tcData?.tc_program?._id;

    try {
      const result = await dispatch(getCompanies({ programId }));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleGoBack = () => {
    navigate("/client/transaction-certificates");
  };

  const getDetails = () => {
    try {
      setStatus("pending");
      dispatch(getTCDetails(id));
      setStatus("success");
    } catch (error) {
      console.error(error.message);
    }
  };

  // const handleDocumentIdChange = (e, documentType) => {
  //   const { value } = e.target;

  //   setTcData((prevState) => {
  //     return {
  //       ...prevState,
  //       [documentType]: prevState[documentType]?.map((doc, index) =>
  //         index === 0 ? { ...doc, documentId: value } : doc
  //       ),
  //     };
  //   });
  // };

  const approveAction = () => {
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(acceptIncomingTC(id));
      setStatus("success");
      setIsLoading(false);
      navigate("/client/transaction-certificates");
    } catch (error) {
      setStatus("failed");
      setIsLoading(false);
    }
  };

  const rejectAction = () => {
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(rejectIncomingTC(id));
      setStatus("success");
      setIsLoading(false);
      navigate("/client/transaction-certificates");
    } catch (error) {
      setStatus("failed");
      setIsLoading(false);
    }
  };

  const getProcessName = (processId) => {
    return processValues.filter((process) => process.id === processId)?.[0]
      ?.value;
  };

  const handleInvoiceFileChange = (event) => {
    handleFileChange(event, setInvoiceFile);
  };

  const handleTransportFileChange = (event) => {
    handleFileChange(event, setTransportFile);
  };

  const handleDocumentFileChange = (event) => {
    handleFileChange(event, setDocumentFile);
  };

  const handleSelectChange = async (
    productIdx,
    inputIdx,
    selectedInventoryId
  ) => {
    // Set the inventory ID to trigger the API call
    setInventoryId(selectedInventoryId);

    // Fetch the inventory details
    const response = await getOneInventoryDetails(selectedInventoryId);
    const details = response?.data;

    // Update the input with fetched details
    updateInputInventory(productIdx, inputIdx, selectedInventoryId, details);
  };

  const updateInputInventory = (
    productIdx,
    inputIdx,
    selectedInventoryId,
    inventoryDetails
  ) => {
    const productsA = [...products];
    const currentProduct = productsA[productIdx];
    const inputs = [...currentProduct.inputs];

    const currentInput = {
      consumedQuantity: inputs[inputIdx].consumedQuantity,
      inventoryName: selectedInventoryId,
      inventoryDetails: inventoryDetails?._id,
      productClassification: inventoryDetails?.productClassification,
      procurementId: inventoryDetails?.procurementId,
      availableQuantity: inventoryDetails?.remainingQuantity,
    };

    inputs[inputIdx] = currentInput;
    currentProduct.inputs = inputs;
    productsA[productIdx] = currentProduct;

    setProducts(productsA);
  };

  const handleFileChange = (event, setFileState) => {
    const file = event.target.files[0];
    const maxSize = 10 * 1024 * 1024;

    if (!file) {
      setErrorMessage("No file selected.");
      toast.error("No file selected.");
      return;
    }

    const result = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      maxSize
    );

    if (!result.isValid) {
      setErrorMessage(result.error);
      toast.error(result.error);
      return;
    }

    setFileState(file);
    setErrorMessage("");

    toast.success("File Uploaded Successfully");
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const updateCertifiedInputs = (productIndex, key, e) => {
    const { name, value } = e.target;

    const productsA = [...products];
    let currentProduct = productsA[productIndex];
    if (key === "product") {
      currentProduct = { ...currentProduct, [name]: value };
    }
    let currentCompostion = {
      ...currentProduct.certifiedMaterial,
    };
    if (key === "composition") {
      currentCompostion = { ...currentCompostion, [name]: value };
    }
    let certifiedWeight = parseFloat(
      (currentProduct.netWeight * (currentCompostion.percentage / 100)).toFixed(
        3
      ) || 0
    );
    let consumption = parseFloat(
      ((certifiedWeight * 100) / (100 - currentCompostion.lossPercent)).toFixed(
        3
      ) || 0
    );

    currentCompostion.certifiedWeight = certifiedWeight;
    currentCompostion.consumption = consumption;

    currentProduct.certifiedMaterial = currentCompostion;
    productsA[productIndex] = currentProduct;
    setProducts(productsA);
  };

  const updateInput = (value, field, field2 = null, idx) => {
    const updatedProduct = [...products];
    const selectedProduct = updatedProduct[idx];
    if (field2) {
      selectedProduct[field][field2] = value;
    } else {
      selectedProduct[field] = value;
    }
    updatedProduct[idx] = selectedProduct;
    setProducts(updatedProduct);
  };

  const recalculateUpdatedInputs = (index, e) => {
    let productsA = [...products];
    const currentProduct = {
      ...productsA[index],
      netWeight: parseFloat(e.target.value),
    };
    let ncComposition = [...currentProduct.nonCertifiedMaterials];
    ncComposition = ncComposition.map((item) => {
      let nonCertifiedWeight = parseFloat(
        (currentProduct.netWeight * (item?.percentage / 100)).toFixed(3) || 0
      );

      let consumption = parseFloat(
        ((nonCertifiedWeight * 100) / (100 - item?.lossPercent)).toFixed(3) || 0
      );
      item.nonCertifiedWeight = nonCertifiedWeight;
      item.consumption = consumption;
      return item;
    });
    currentProduct.nonCertifiedMaterials = ncComposition;
    productsA[index] = currentProduct;
    setProducts(productsA);
  };

  const updateNcInput = (productIdx, ncIdx, e) => {
    let { name, value } = e.target;

    const productsA = [...products];

    let currentProduct = productsA[productIdx];

    let ncCompostion = [...currentProduct.nonCertifiedMaterials];

    let currentCompostion = {
      ...ncCompostion[ncIdx],
      [name]: value,
    };

    let nonCertifiedWeight = parseFloat(
      (
        currentProduct.netWeight *
        (currentCompostion?.percentage / 100)
      ).toFixed(3) || 0
    );

    let consumption = parseFloat(
      (
        (nonCertifiedWeight * 100) /
        (100 - currentCompostion?.lossPercent)
      ).toFixed(3) || 0
    );
    currentCompostion.nonCertifiedWeight = nonCertifiedWeight;
    currentCompostion.consumption = consumption;

    ncCompostion[ncIdx] = currentCompostion;

    currentProduct.nonCertifiedMaterials = ncCompostion;
    productsA[productIdx] = currentProduct;
    setProducts(productsA);
  };

  const updateInputItem = (productIdx, ncIdx, e) => {
    let { name, value } = e.target;
    if (!isNaN(value) && value.trim() !== "") {
      value = Number(value);
    }
    const productsA = [...products];

    let currentProduct = productsA[productIdx];

    let inputs = [...currentProduct.inputs];

    let currentInput = {
      ...inputs[ncIdx],
      [name]: value,
    };

    inputs[ncIdx] = currentInput;

    currentProduct.inputs = inputs;
    productsA[productIdx] = currentProduct;
    setProducts(productsA);
  };

  // const updateInputInventory = (productIdx, inputIdx, selectedInventoryId) => {
  //   const productsA = [...products];

  //   const currentProduct = productsA[productIdx];

  //   const inputs = [...currentProduct.inputs];
  //   console.log(inventoryDetails)

  //   const currentInput = {
  //     consumedQuantity: inputs[inputIdx].consumedQuantity,
  //     inventoryName: selectedInventoryId,
  //     inventoryDetails: inventoryDetails?._id,
  //     productClassification: inventoryDetails?.productClassification,
  //     procurementId: inventoryDetails?.procurementId,
  //     availableQuantity: inventoryDetails?.remainingQuantity,
  //   };
  //   console.log(currentInput)

  //   inputs[inputIdx] = currentInput;

  //   currentProduct.inputs = inputs;

  //   productsA[productIdx] = currentProduct;
  //   console.log(productsA)

  //   setProducts(productsA);
  // };

  const handleDocumentSubmit = async () => {
    let invoiceReportRequest, transportReportRequest, documentReportRequest;
    const token = localStorage.getItem("cu_user");
    try {
      if (invoiceFile) {
        const invoiceReportData = new FormData();

        invoiceReportData.append("document", invoiceFile);
        invoiceReportData.append("doc_type", "OTHER");
        invoiceReportData.append("documentInfo", "OTHER");

        invoiceReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: invoiceReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (transportFile) {
        const transportReportData = new FormData();

        transportReportData.append("document", transportFile);
        transportReportData.append("doc_type", "OTHER");
        transportReportData.append("documentInfo", "OTHER");

        transportReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: transportReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (documentFile) {
        const legalReportData = new FormData();

        legalReportData.append("document", documentFile);
        legalReportData.append("doc_type", "OTHER");
        legalReportData.append("documentInfo", "OTHER");

        documentReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: legalReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }
      return {
        invoiceId: invoiceReportRequest?.data?.data?.id,
        transportId: transportReportRequest?.data?.data?.id,
        documentId: documentReportRequest?.data?.data?.id,
      };
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const getProcessList = async () => {
    let responseData = companyDetails?.data?.company_processes?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });

    setProcessValues(responseData);
    const selected = tcData?.tc_processes?.map((tcProcess) => tcProcess.name);
    setSelectedProcesses(selected);
  };

  const getCompanyInventories = async () => {
    const response = await getInventory();
    setCompanyInventories(response?.data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setTcData((prevState) => {
      const newState = { ...prevState };
      if (name.includes(".")) {
        const keys = name.split(".");
        let obj = newState;
        for (let i = 0; i < keys.length - 1; i++) {
          if (typeof obj[keys[i]] === "object" && obj[keys[i]] !== null) {
            obj[keys[i]] = { ...obj[keys[i]] };
          }
          obj = obj[keys[i]];
        }
        obj[keys[keys.length - 1]] = value;
      } else {
        newState[name] = value;
      }

      return newState;
    });
  };

  // const handleDocumentChange = (index, type, value) => {
  //   setTcData((prevState) => {
  //     const newState = { ...prevState };

  //     if (newState[type] && Array.isArray(newState[type])) {
  //       newState[type] = [...newState[type]];
  //       if (newState[type][index]) {
  //         newState[type][index] = {
  //           ...newState[type][index],
  //           documentId: value,
  //         };
  //       }
  //     }
  //     return newState;
  //   });
  // };

  const handleDocumentChange = (field, value) => {
    setTcData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleUpdateTc = () => {
    try {
      const updatedTcData = {
        ...tcData,
        products: products,
        ...(buyerId && { buyerId }),
        ...(consigneeId && { consigneeId }),
        ...(lastProcessorId && { lastProcessorId }),
        ...(unitId && { unitId }),
        ...(programId && { programId }),
        ...(processes && { processes: processes.map((process) => process.id) }),
      };
      console.log(updatedTcData);
      //make sure that total net weight certified weight and gross weight in api call
      const result = dispatch(updateTcForm(updatedTcData, id));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    if (companyDetails && tcData) {
      getProcessList();
    }
  }, [companyDetails, tcData]);

  useEffect(() => {
    getBuyersCompanyUnit();
  }, [consigneeId]);

  useEffect(() => {
    getSellersCompanyUnit();
  }, [lastProcessorId]);

  useEffect(() => {
    getInventoryDetails();
  }, [inventoryId]);

  useEffect(() => {
    let grossWeight = 0;
    let netWeight = 0;
    let certifiedWeightValue = 0;
    products?.forEach((product) => {
      if ("grossWeight" in product) {
        grossWeight += parseFloat(product?.grossWeight);
      }
      if ("netWeight" in product) {
        netWeight += parseFloat(product?.netWeight);
      }
      if (
        "certifiedMaterial" in product &&
        "certifiedWeight" in product?.certifiedMaterial
      ) {
        certifiedWeightValue += parseFloat(
          product.certifiedMaterial.certifiedWeight
        );
      }
    });

    setTotalGrossWeigth(grossWeight);
    setTotalNetWeigth(netWeight);
    setTotalCertifiedWeigth(certifiedWeightValue);
  }, [products]);

  useEffect(() => {
    const remarks = tcData?.remarks?.filter((data) => data.comment);
    setRemarks(remarks);
  }, []);

  useEffect(() => {
    getDetails();
    getBuyersData();
    getCompany();
  }, [buyerId]);

  useEffect(() => {
    setInitialProductValues();
    getProcessList();
    getAllCompanies();
    getBuyersCompany();
    setCheckedItems(() => {
      if (tcData?.tc_buyer?._id) {
        setBuyerId(tcData?.tc_buyer?._id);
        return [true, false];
      } else {
        return [false, true];
      }
    });
  }, [tcData, buyerId]);

  useEffect(() => {
    if (userData?.companyId) {
      getCompany();
      getCompanyInventories();
    }
  }, [userData]);

  return (
    <>
      <Box marginTop="2rem">
        <Box
          display={"flex"}
          alignItems="center"
          cursor={"pointer"}
          onClick={handleGoBack}
        >
          <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
          &nbsp;
          <Text
            color={"#52BBFF"}
            fontSize={{ base: "sm", md: "sm", lg: "md" }}
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Go Back
          </Text>
        </Box>
        <Text
          mt="1rem"
          color={"#141D43"}
          fontSize="2xl"
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Transaction Certificate
        </Text>
      </Box>
      <Box>
        <Box
          marginTop={"1.5rem"}
          bg={
            "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
          }
          borderTopRightRadius="100px"
          borderBottomRightRadius={"80px 80px"}
          color={"#fff"}
          padding={"10px 2rem"}
          fontWeight="700"
          marginLeft="-2rem"
          marginRight={"-2.5rem"}
        >
          TC #{tcData?.tcApplicationNumber}
        </Box>
        <Box marginTop="2rem">
          <Grid
            templateColumns={{
              base: "1fr",
              md: "1fr",
              lg: "repeat(3, 1fr)",
            }}
            gap={{ base: "1rem", md: "1rem", xl: "0rem" }}
          >
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Unit &nbsp;
                <Text as="span" color="red">
                  *
                </Text>
              </Text>
              <Select
                _placeholder={{
                  opacity: 1,
                  color: "#141D43",
                  fontSize: "14px",
                }}
                isDisabled={editable == 2 ? false : true}
                color={"#141D43"}
                border="2px solid  #8fd0fd !important"
                marginTop="10px"
                w="80%"
                bg={"#fff"}
                name="tc_companyUnit._id"
                value={tcData?.tc_companyUnit?._id}
                onChange={(e) => {
                  const value = e.target.value;
                  handleChange({
                    target: {
                      name: "tc_companyUnit._id",
                      value,
                    },
                  });
                  setUnitId(value);
                }}
              >
                <option hidden="true">Select Unit</option>
                {companyDetails?.data?.company_units?.map((unit, index) => (
                  <option key={index} value={unit._id}>
                    {unit?.name} - {unit?.unitType}
                  </option>
                ))}
              </Select>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Certification Applying For &nbsp;
                <Text as="span" color="red">
                  *
                </Text>
              </Text>
              <Select
                _placeholder={{
                  opacity: 1,
                  color: "#141D43",
                  fontSize: "14px",
                }}
                color={"#141D43"}
                border="2px solid  #8fd0fd !important"
                marginTop="10px"
                w="80%"
                bg={"#fff"}
                id="certificationBodyId"
                value={tcData?.tc_program?._id}
                onChange={(e) => {
                  const value = e.target.value;
                  handleChange({
                    target: {
                      name: "tc_program._id",
                      value,
                    },
                  });
                  setProgramId(value);
                }}
                isDisabled={editable == 2 ? false : true}
              >
                <option hidden="true">Select Certification</option>
                {companyDetails?.data?.company_programs?.map(
                  (program, index) => (
                    <option key={index} value={program._id}>
                      {program?.name}
                    </option>
                  )
                )}
              </Select>
            </GridItem>
          </Grid>
        </Box>

        <Box>
          <Grid templateColumns={"repeat(2,1fr)"} gap={"1rem"}>
            <GridItem>
              <Box
                bg="#FFFFFF"
                padding={"2rem"}
                marginTop="2rem"
                borderRadius={"15px"}
                h="359px"
              >
                {TC?.status === "PENDING" &&
                  editable == 2 &&
                  TC?.stage === "CLIENT" && (
                    <Box
                      display={"flex"}
                      justifyContent="right"
                      alignItems={"center"}
                      gap="20px"
                    >
                      <Box>
                        <Checkbox
                          colorScheme={"checkbox"}
                          defaultChecked
                          isChecked={checkedItems[1]}
                          onChange={() => handleCheckboxChange(1)}
                          fontWeight={"500"}
                          isDisabled
                        >
                          Non Registered
                        </Checkbox>
                      </Box>
                      <Box>
                        <Checkbox
                          colorScheme={"checkbox"}
                          fontWeight={"500"}
                          isChecked={checkedItems[0]}
                          onChange={() => handleCheckboxChange(0)}
                          isDisabled
                        >
                          Registered
                        </Checkbox>
                      </Box>
                    </Box>
                  )}

                <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                  <Box
                    as="span"
                    borderRight={"3px solid #2272D5"}
                    height="40px"
                    marginRight={"1rem"}
                  ></Box>
                  Buyer Details
                  {TC?.buyerDetails?.name ? (
                    <Badge ml="1rem" colorScheme="red">
                      UNREGISTERED
                    </Badge>
                  ) : (
                    <Badge ml="1rem" colorScheme="green">
                      REGISTERED
                    </Badge>
                  )}
                </Text>
                {checkedItems[0] && (
                  <Box
                    display={"flex"}
                    flexDirection="column"
                    alignItems="flex-start"
                    py="1rem"
                    paddingLeft={"3rem"}
                    justifyContent={"center"}
                  >
                    <Grid
                      width={"100%"}
                      templateColumns="repeat(2, 1fr)"
                      my={"1rem"}
                      gap="1rem"
                    >
                      <GridItem colSpan={1}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Name
                        </Text>
                        {TC?.status === "PENDING" &&
                        editable == 2 &&
                        TC?.stage === "CLIENT" ? (
                          <SelectSearch
                            options={buyers}
                            value={tcData?.tc_buyer?._id}
                            search
                            onChange={(value) =>
                              handleChange({
                                target: { name: "tc_buyer._id", value },
                              })
                            }
                          />
                        ) : (
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {tcData?.tc_buyer?.name ||
                              tcData?.buyerDetails?.name}
                          </Text>
                        )}
                      </GridItem>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Country
                        </Text>
                        <Text marginTop="10px" w="100%" fontSize={"14px"}>
                          {buyerCompany?.address?.raw_address
                            ? buyerCompany?.address?.country
                            : tcData?.tc_buyer?.address?.country ||
                              tcData?.buyerDetails?.country}
                        </Text>
                      </GridItem>
                    </Grid>
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Address
                      </Text>

                      <Text marginTop="10px" w="100%" fontSize={"14px"}>
                        {buyerCompany?.address?.raw_address
                          ? `${buyerCompany?.address?.raw_address}, ${buyerCompany?.address?.city},  ${buyerCompany?.address?.state}, ${buyerCompany?.address?.pinCode}`
                          : tcData?.tc_buyer?.address?.raw_address
                          ? `${tcData?.tc_buyer?.address?.raw_address},${tcData?.tc_buyer?.address?.city}, ${tcData?.tc_buyer?.address?.state}, ${tcData?.tc_buyer?.address?.pinCode}`
                          : tcData?.buyerDetails?.address}
                      </Text>
                    </GridItem>
                  </Box>
                )}
                {checkedItems[1] && (
                  <Box paddingLeft={"3rem"} mb="1.6rem">
                    <Box>
                      <Grid
                        alignItems={"flex-end"}
                        gap={"1rem"}
                        templateColumns="repeat(1, 1fr)"
                        marginTop={"10px"}
                      >
                        <Box
                          display={"flex"}
                          flexDirection="column"
                          alignItems="flex-start"
                          justifyContent={"center"}
                        >
                          <Grid
                            width={"100%"}
                            templateColumns="repeat(2, 1fr)"
                            my={"1rem"}
                            gap="1rem"
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Name &nbsp;
                              </Text>
                              {TC?.status === "PENDING" &&
                              editable == 2 &&
                              TC?.stage === "CLIENT" ? (
                                <Input
                                  type="text"
                                  color={"#141D43"}
                                  border="2px solid  #8fd0fd !important"
                                  marginTop="10px"
                                  bg={"#fff"}
                                  id="buyerName"
                                  value={tcData?.buyerDetails?.name}
                                  onChange={handleChange}
                                  name="buyerDetails.name"
                                  _placeholder={{
                                    opacity: 1,
                                    color: " #464C64",
                                    fontSize: "14px",
                                  }}
                                />
                              ) : (
                                <Text
                                  marginTop="10px"
                                  w="100%"
                                  fontSize={"14px"}
                                >
                                  {tcData?.buyerDetails?.name}
                                </Text>
                              )}
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Country &nbsp;
                              </Text>
                              {TC?.status === "PENDING" &&
                              editable == 2 &&
                              TC?.stage === "CLIENT" ? (
                                <Input
                                  type="tel"
                                  color={"#141D43"}
                                  border="2px solid  #8fd0fd !important"
                                  marginTop="10px"
                                  bg={"#fff"}
                                  w={"100%"}
                                  id="buyerCountry"
                                  isDisabled={editable == 2 ? false : true}
                                  value={tcData?.buyerDetails?.country}
                                  onChange={handleChange}
                                  name="buyerDetails.country"
                                  _placeholder={{
                                    opacity: 1,
                                    color: " #464C64",
                                    fontSize: "14px",
                                  }}
                                />
                              ) : (
                                <Text
                                  marginTop="10px"
                                  w="100%"
                                  fontSize={"14px"}
                                >
                                  {tcData?.buyerDetails?.country}
                                </Text>
                              )}
                            </GridItem>
                          </Grid>
                          <GridItem width={"100%"}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Address &nbsp;
                            </Text>
                            {TC?.status === "PENDING" &&
                            editable == 2 &&
                            TC?.stage === "CLIENT" ? (
                              <Input
                                type="tel"
                                color={"#141D43"}
                                marginTop="10px"
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                bg={"#fff"}
                                isDisabled={editable == 2 ? false : true}
                                id="buyerAddress"
                                value={tcData?.buyerDetails?.address}
                                onChange={handleChange}
                                name="buyerDetails.address"
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            ) : (
                              <Text marginTop="10px" w="100%" fontSize={"14px"}>
                                {tcData?.buyerDetails?.address}
                              </Text>
                            )}
                          </GridItem>
                        </Box>
                        <Box marginTop="35px"></Box>
                      </Grid>
                    </Box>
                  </Box>
                )}
              </Box>
            </GridItem>
            <GridItem>
              <Box
                bg="#FFFFFF"
                padding={"2rem"}
                marginTop="2rem"
                borderRadius={"15px"}
                h="359px"
              >
                <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                  Consignee Details
                </Text>
                {checkedItems[0] && (
                  <Box paddingLeft={"3rem"}>
                    <Box>
                      <Grid
                        alignItems={"flex-end"}
                        gap={"1rem"}
                        templateColumns="repeat(1, 1fr)"
                        marginTop={"1rem"}
                      >
                        <Box
                          display={"flex"}
                          flexDirection="column"
                          alignItems="flex-start"
                          justifyContent={"center"}
                        >
                          <Grid
                            width={"100%"}
                            templateColumns="repeat(2, 1fr)"
                            my={"1rem"}
                            gap="1rem"
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Name
                              </Text>
                              {TC?.status === "PENDING" &&
                              editable == 2 &&
                              TC?.stage === "CLIENT" ? (
                                <Select
                                  value={tcData?.tc_consignee?._id}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    handleChange({
                                      target: {
                                        name: "tc_consignee._id",
                                        value: selectedValue,
                                      },
                                    });
                                    setConsigneeId(selectedValue);
                                  }}
                                >
                                  {" "}
                                  <option hidden="true">
                                    Select Consignee Unit
                                  </option>
                                  {buyerCompany?.company_units?.map(
                                    (program, index) => (
                                      <option key={index} value={program._id}>
                                        {program?.name}
                                      </option>
                                    )
                                  )}{" "}
                                </Select>
                              ) : (
                                <Text
                                  marginTop="10px"
                                  w="100%"
                                  fontSize={"14px"}
                                >
                                  {tcData?.tc_consignee?.name ||
                                    tcData?.consigneeDetails?.name}
                                </Text>
                              )}
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Country
                              </Text>
                              <Text marginTop="10px" w="100%" fontSize={"14px"}>
                                {consignee?.address?.country
                                  ? consignee?.address?.country
                                  : tcData?.tc_consignee?.address?.country ||
                                    tcData?.consigneeDetails?.country}
                              </Text>
                            </GridItem>
                          </Grid>
                          <GridItem width={"100%"}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Address
                            </Text>

                            <Text marginTop="10px" w="100%" fontSize={"14px"}>
                              {consignee?.address?.raw_address
                                ? `${consignee?.address?.raw_address}, ${consignee?.address?.city}, ${consignee?.address?.state}, ${consignee?.address?.pinCode}`
                                : tcData?.tc_consignee?.address?.raw_address
                                ? `${tcData?.tc_consignee?.address?.raw_address}, ${tcData?.tc_consignee?.address?.city}, ${tcData?.tc_consignee?.address?.state}, ${tcData?.tc_consignee?.address?.pinCode}`
                                : tcData?.consigneeDetails?.address}
                            </Text>
                          </GridItem>
                        </Box>
                        <Box marginTop="35px"></Box>
                      </Grid>
                    </Box>
                  </Box>
                )}
                {checkedItems[1] && (
                  <Box paddingLeft={"3rem"} mb="1.6rem">
                    <Box>
                      <Grid
                        alignItems={"flex-end"}
                        gap={"1rem"}
                        templateColumns="repeat(1, 1fr)"
                        marginTop={"10px"}
                      >
                        <Box
                          display={"flex"}
                          flexDirection="column"
                          alignItems="flex-start"
                          justifyContent={"center"}
                        >
                          <Grid
                            width={"100%"}
                            templateColumns="repeat(2, 1fr)"
                            my={"1rem"}
                            gap="1rem"
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Name &nbsp;
                              </Text>
                              {TC?.status === "PENDING" &&
                              editable == 2 &&
                              TC?.stage === "CLIENT" ? (
                                <Input
                                  type="text"
                                  color={"#141D43"}
                                  border="2px solid  #8fd0fd !important"
                                  marginTop="10px"
                                  bg={"#fff"}
                                  id="consigneeName"
                                  isDisabled={editable == 2 ? false : true}
                                  value={tcData?.consigneeDetails?.name}
                                  onChange={handleChange}
                                  name="consigneeDetails.name"
                                  _placeholder={{
                                    opacity: 1,
                                    color: " #464C64",
                                    fontSize: "14px",
                                  }}
                                />
                              ) : (
                                <Text
                                  marginTop="10px"
                                  w="100%"
                                  fontSize={"14px"}
                                >
                                  {tcData?.consigneeDetails?.name}
                                </Text>
                              )}
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Country &nbsp;
                                <Text as="span" color="red">
                                  *
                                </Text>
                              </Text>
                              {TC?.status === "PENDING" &&
                              editable == 2 &&
                              TC?.stage === "CLIENT" ? (
                                <Input
                                  type="tel"
                                  color={"#141D43"}
                                  border="2px solid  #8fd0fd !important"
                                  marginTop="10px"
                                  bg={"#fff"}
                                  isDisabled={editable == 2 ? false : true}
                                  w={"100%"}
                                  id="consigneeCountry"
                                  value={tcData?.consigneeDetails?.country}
                                  onChange={handleChange}
                                  name="consigneeDetails.country"
                                  _placeholder={{
                                    opacity: 1,
                                    color: " #464C64",
                                    fontSize: "14px",
                                  }}
                                />
                              ) : (
                                <Text
                                  marginTop="10px"
                                  w="100%"
                                  fontSize={"14px"}
                                >
                                  {tcData?.consigneeDetails?.country}
                                </Text>
                              )}
                            </GridItem>
                          </Grid>
                          <GridItem width={"100%"}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Address &nbsp;
                            </Text>

                            {TC?.status === "PENDING" &&
                            editable == 2 &&
                            TC?.stage === "CLIENT" ? (
                              <Input
                                type="tel"
                                color={"#141D43"}
                                marginTop="10px"
                                border="2px solid  #8fd0fd !important"
                                w="100%"
                                bg={"#fff"}
                                id="consigneeAddress"
                                value={tcData?.consigneeDetails?.address}
                                onChange={handleChange}
                                name="consigneeDetails.address"
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            ) : (
                              <Text marginTop="10px" w="100%" fontSize={"14px"}>
                                {tcData?.consigneeDetails?.address}
                              </Text>
                            )}
                          </GridItem>
                        </Box>
                        <Box marginTop="35px"></Box>
                      </Grid>
                    </Box>
                  </Box>
                )}
              </Box>
            </GridItem>
          </Grid>
        </Box>
        <Box>
          <Grid templateColumns={"repeat(2, 1fr)"} gap={"1rem"}>
            <GridItem>
              <Box
                bg="#FFFFFF"
                padding={"2rem"}
                marginTop="2rem"
                borderRadius={"15px"}
                h="359px"
              >
                <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                  Seller Details (Applicant)
                </Text>
                <Box
                  border={"2px solid #2272D5"}
                  width="15%"
                  marginBottom={"1rem"}
                  mt="1rem"
                ></Box>
                <Box paddingLeft={"3rem"}>
                  <Box>
                    <Grid
                      alignItems={"flex-end"}
                      gap={"1rem"}
                      templateColumns="repeat(1, 1fr)"
                      marginTop={"1rem"}
                    >
                      <Box
                        display={"flex"}
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent={"center"}
                      >
                        <Grid
                          width={"100%"}
                          templateColumns="repeat(2, 1fr)"
                          my={"1rem"}
                          gap="1rem"
                        >
                          <GridItem colSpan={1}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Name
                            </Text>
                            <Text marginTop="10px" w="100%" fontSize={"14px"}>
                              {tcData?.tc_seller?.name}
                            </Text>
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Country
                            </Text>
                            <Text marginTop="10px" w="100%" fontSize={"14px"}>
                              {tcData?.tc_seller?.address?.country}
                            </Text>
                          </GridItem>
                        </Grid>
                        <GridItem width={"100%"}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Address
                          </Text>
                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {tcData?.tc_seller?.address?.raw_address}
                          </Text>
                        </GridItem>
                      </Box>
                      <Box marginTop="35px"></Box>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </GridItem>
            <GridItem>
              <Box
                bg="#FFFFFF"
                padding={"2rem"}
                marginTop="2rem"
                borderRadius={"15px"}
                h="359px"
              >
                <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                  Last Processor Details
                </Text>
                <Box
                  border={"2px solid #2272D5"}
                  width="15%"
                  marginBottom={"1rem"}
                  mt="1rem"
                ></Box>
                <Box paddingLeft={"3rem"}>
                  <Box>
                    <Grid
                      alignItems={"flex-end"}
                      gap={"1rem"}
                      templateColumns="repeat(1, 1fr)"
                      marginTop={"1rem"}
                    >
                      <Box
                        display={"flex"}
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent={"center"}
                      >
                        <Grid
                          width={"100%"}
                          templateColumns="repeat(2, 1fr)"
                          my={"1rem"}
                          gap="1rem"
                        >
                          <GridItem colSpan={1}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Name
                            </Text>
                            {TC?.status === "PENDING" &&
                            editable == 2 &&
                            TC?.stage === "CLIENT" ? (
                              <Select
                                value={tcData?.tc_lastProcessor?._id}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  handleChange({
                                    target: {
                                      name: "tc_lastProcessor._id",
                                      value,
                                    },
                                  });
                                  setLastProcessorId(value);
                                }}
                              >
                                <option hidden="true">Select Unit</option>
                                {companyDetails?.data?.company_units?.map(
                                  (unit, index) => (
                                    <option key={index} value={unit._id}>
                                      {unit?.name} - {unit?.unitType}
                                    </option>
                                  )
                                )}{" "}
                              </Select>
                            ) : (
                              <Text marginTop="10px" w="100%" fontSize={"14px"}>
                                {tcData?.tc_lastProcessor?.name ||
                                  tcData?.lastProcessorDetails?.name}
                              </Text>
                            )}
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Country
                            </Text>
                            <Text marginTop="10px" w="100%" fontSize={"14px"}>
                              {lastProcessor?.address?.country
                                ? lastProcessor?.address?.country
                                : tcData?.tc_lastProcessor?.address?.country ||
                                  tcData?.lastProcessorDetails?.country}
                            </Text>
                          </GridItem>
                        </Grid>
                        <GridItem width={"100%"}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Address
                          </Text>

                          <Text marginTop="10px" w="100%" fontSize={"14px"}>
                            {lastProcessor?.address?.raw_address
                              ? `${lastProcessor?.address?.raw_address}, ${lastProcessor?.address?.city}, ${lastProcessor?.address?.state}, ${lastProcessor?.address?.country}`
                              : tcData?.tc_lastProcessor?.address?.raw_address
                              ? `${tcData?.tc_lastProcessor?.address?.raw_address}, ${tcData?.tc_lastProcessor?.address?.city}, ${tcData?.tc_lastProcessor?.address?.state}, ${tcData?.tc_lastProcessor?.address?.pinCode}`
                              : tcData?.lastProcessorDetails?.address}
                          </Text>
                        </GridItem>
                      </Box>
                      <Box marginTop="35px"></Box>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </GridItem>
          </Grid>
        </Box>
        <Box
          bg="#FFFFFF"
          padding={"2rem"}
          marginTop="2rem"
          borderRadius={"15px"}
        >
          <Grid templateColumns="repeat(1, 1fr)" gap="1rem">
            <GridItem>
              <Box
                bg="#FFFFFF"
                padding={"2rem"}
                marginTop="2rem"
                borderRadius={"15px"}
              >
                <Box display={"flex"} justifyContent="space-between">
                  <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                    <Box
                      as="span"
                      borderRight={"3px solid #2272D5"}
                      height="40px"
                      marginRight={"1rem"}
                    ></Box>
                    Product and Shipment Details
                  </Text>
                </Box>
                <Accordion defaultIndex={[0]} marginTop={"2rem"}>
                  {products ? (
                    products?.map((product, index) => (
                      <AccordionItem>
                        <h2>
                          <AccordionButton>
                            <Box as="span" flex="1" textAlign="left">
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                {product?.productName
                                  ? product?.productName
                                  : "N/A"}
                                ({product?.process?.map((prc) => (
                                  <Text as="span"> {prc?.name}, </Text>
                                ))})
                              </Text>
                            </Box>
                            <AccordionIcon />
                          </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                          <Box marginBottom={"1rem"} key={product._id}>
                            <Grid templateColumns="repeat(2, 1fr)" gap="1rem">
                              <GridItem>
                                <Box
                                  bg="#FFFFFF"
                                  padding={"2rem"}
                                  borderRadius={"15px"}
                                >
                                  <Box paddingLeft={"3rem"}>
                                    <Box>
                                      <Grid
                                        templateColumns={"repeat(2, 1fr)"}
                                        gap="1rem"
                                        mt="1rem"
                                      >
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Invoice No.
                                          </Text>
                                          {TC?.status === "PENDING" &&
                                          editable == 2 &&
                                          TC?.stage === "CLIENT" ? (
                                            <Input
                                              color={"#141D43"}
                                              marginTop="10px"
                                              border="2px solid  #8fd0fd !important"
                                              w="100%"
                                              name="invoiceNo"
                                              opacity={"1 !important"}
                                              bg={"#fff"}
                                              value={product?.invoiceNo}
                                              onChange={(e) => {
                                                updateCertifiedInputs(
                                                  index,
                                                  "product",
                                                  e
                                                );
                                              }}
                                              fontSize={"14px"}
                                              _placeholder={{
                                                opacity: 1,
                                                color: "#141D43",
                                                fontSize: "14px",
                                              }}
                                            />
                                          ) : (
                                            <Text
                                              marginTop="10px"
                                              w="100%"
                                              fontSize={"14px"}
                                            >
                                              {product?.invoiceNo || "N/A"}
                                            </Text>
                                          )}
                                        </GridItem>
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Invoice Date
                                          </Text>
                                          {TC?.status === "PENDING" &&
                                          TC?.stage === "CLIENT" ? (
                                            <Input
                                              type="date"
                                              color={"#141D43"}
                                              marginTop="10px"
                                              border="2px solid  #8fd0fd !important"
                                              w="100%"
                                              name="invoiceDate"
                                              opacity={"1 !important"}
                                              bg={"#fff"}
                                              value={
                                                product?.invoiceDate
                                                  ? new Date(
                                                      product?.invoiceDate
                                                    )
                                                      .toISOString()
                                                      .split("T")[0]
                                                  : ""
                                              }
                                              onChange={(e) => {
                                                updateCertifiedInputs(
                                                  index,
                                                  "product",
                                                  e
                                                );
                                              }}
                                              fontSize={"14px"}
                                              _placeholder={{
                                                opacity: 1,
                                                color: "#141D43",
                                                fontSize: "14px",
                                              }}
                                            />
                                          ) : (
                                            <Text
                                              color={"#141D43"}
                                              fontSize="md"
                                              fontWeight={"400"}
                                              fontFamily={"font.roboto"}
                                              marginTop={"1rem"}
                                            >
                                              {moment(
                                                product?.invoiceDate
                                              ).format("DD-MM-YYYY")}
                                            </Text>
                                          )}
                                        </GridItem>
                                      </Grid>
                                      <Grid
                                        templateColumns="repeat(2,1fr)"
                                        gap="1rem"
                                        mt={"1rem"}
                                      >
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Net Weight (kg)
                                          </Text>
                                          {TC?.status === "PENDING" &&
                                          TC?.stage === "CLIENT" ? (
                                            <Input
                                              color={"#141D43"}
                                              marginTop="10px"
                                              type="number"
                                              border="2px solid  #8fd0fd !important"
                                              w="100%"
                                              bg={"#fff"}
                                              name="netWeight"
                                              opacity={"1 !important"}
                                              fontSize={"14px"}
                                              value={product.netWeight}
                                              onChange={(e) => {
                                                updateCertifiedInputs(
                                                  index,
                                                  "product",
                                                  e
                                                );
                                                recalculateUpdatedInputs(
                                                  index,
                                                  e
                                                );
                                              }}
                                              _placeholder={{
                                                opacity: 1,
                                                color: "#141D43",
                                                fontSize: "14px",
                                              }}
                                            />
                                          ) : (
                                            <Text
                                              color={"#141D43"}
                                              fontSize="md"
                                              fontWeight={"400"}
                                              fontFamily={"font.roboto"}
                                              marginTop={"1rem"}
                                            >
                                              {product?.netWeight}
                                            </Text>
                                          )}
                                        </GridItem>
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Gross Weight (kg)
                                          </Text>
                                          {TC?.status === "PENDING" &&
                                          TC?.stage === "CLIENT" ? (
                                            <Input
                                              color={"#141D43"}
                                              marginTop="10px"
                                              type="number"
                                              name="grossWeight"
                                              opacity={"1 !important"}
                                              border="2px solid  #8fd0fd !important"
                                              w="100%"
                                              bg={"#fff"}
                                              value={product.grossWeight}
                                              onChange={(e) => {
                                                updateCertifiedInputs(
                                                  index,
                                                  "product",
                                                  e
                                                );
                                              }}
                                              fontSize={"14px"}
                                              _placeholder={{
                                                opacity: 1,
                                                color: "#141D43",
                                                fontSize: "14px",
                                              }}
                                            />
                                          ) : (
                                            <Text
                                              color={"#141D43"}
                                              fontSize="md"
                                              fontWeight={"400"}
                                              fontFamily={"font.roboto"}
                                              marginTop={"1rem"}
                                            >
                                              {product?.product?.grossWeight}
                                            </Text>
                                          )}
                                        </GridItem>
                                      </Grid>
                                      <Grid
                                        templateColumns="repeat(2, 1fr)"
                                        gap={"1rem"}
                                        mt="1rem"
                                      >
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Product Category
                                          </Text>
                                          {TC?.status === "PENDING" &&
                                          TC?.stage === "CLIENT" ? (
                                            <Input
                                              isDisabled
                                              value={
                                                product?.productCategoryName
                                              }
                                            />
                                          ) : (
                                            <Text marginTop={"10px"}>
                                              {product?.productCategoryName
                                                ? product?.productCategoryName
                                                : "N/A"}
                                            </Text>
                                          )}
                                        </GridItem>
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Product Classification
                                          </Text>
                                          {TC?.status === "PENDING" &&
                                          TC?.stage === "CLIENT" ? (
                                            <Input
                                              isDisabled
                                              value={
                                                product?.productClassificationName
                                              }
                                            />
                                          ) : (
                                            <Text marginTop={"10px"}>
                                              {product?.productClassificationName
                                                ? product?.productClassificationName
                                                : "N/A"}
                                            </Text>
                                          )}
                                        </GridItem>
                                      </Grid>

                                      <Grid
                                        templateColumns="repeat(1,1fr)"
                                        mt="1rem"
                                        gap={"3rem"}
                                      >
                                        <GridItem>
                                          <Grid
                                            templateColumns="repeat(2,2fr)"
                                            gap="1rem"
                                          >
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Certified Material
                                              </Text>
                                              {TC?.status === "PENDING" &&
                                              TC?.stage === "CLIENT" ? (
                                                <Input
                                                  isDisabled
                                                  value={
                                                    product?.certifiedMaterialName
                                                  }
                                                />
                                              ) : (
                                                <Text marginTop={"10px"}>
                                                  {product?.certifiedMaterialName
                                                    ? product?.certifiedMaterialName
                                                    : "N/A"}
                                                </Text>
                                              )}
                                            </GridItem>
                                            <GridItem>
                                              <Box
                                                display={"flex"}
                                                justifyContent={"center"}
                                                alignItems={"center"}
                                              >
                                                <Box>
                                                  <Text
                                                    color={"#141D43"}
                                                    fontSize="sm"
                                                    fontWeight={"700"}
                                                    fontFamily={"font.roboto"}
                                                  >
                                                    Percentage
                                                  </Text>
                                                  {TC?.status === "PENDING" &&
                                                  TC?.stage === "CLIENT" ? (
                                                    <Input
                                                      color={"#141D43"}
                                                      marginTop="10px"
                                                      type="number"
                                                      border="2px solid  #8fd0fd !important"
                                                      w="60%"
                                                      bg={"#fff"}
                                                      opacity={"1 !important"}
                                                      name="percentage"
                                                      value={
                                                        product
                                                          ?.certifiedMaterial
                                                          ?.percentage
                                                      }
                                                      onChange={(e) => {
                                                        updateCertifiedInputs(
                                                          index,
                                                          "composition",
                                                          e
                                                        );
                                                      }}
                                                      fontSize={"14px"}
                                                      _placeholder={{
                                                        opacity: 1,
                                                        color: "#141D43",
                                                        fontSize: "14px",
                                                      }}
                                                    />
                                                  ) : (
                                                    <Text marginTop={"10px"}>
                                                      {product
                                                        ?.certifiedMaterial
                                                        ?.percentage || "N/A"}
                                                    </Text>
                                                  )}
                                                </Box>
                                                <Box>
                                                  <Text
                                                    color={"#141D43"}
                                                    fontSize="sm"
                                                    fontWeight={"700"}
                                                    fontFamily={"font.roboto"}
                                                  >
                                                    Loss Percent
                                                  </Text>
                                                  {TC?.status === "PENDING" &&
                                                  TC?.stage === "CLIENT" ? (
                                                    <Input
                                                      color={"#141D43"}
                                                      type="number"
                                                      name="lossPercent"
                                                      marginTop="10px"
                                                      opacity={"1 !important"}
                                                      border="2px solid  #8fd0fd !important"
                                                      w="60%"
                                                      bg={"#fff"}
                                                      value={
                                                        product
                                                          ?.certifiedMaterial
                                                          ?.lossPercent
                                                      }
                                                      onChange={(e) => {
                                                        updateCertifiedInputs(
                                                          index,
                                                          "composition",
                                                          e
                                                        );
                                                      }}
                                                      fontSize={"14px"}
                                                      _placeholder={{
                                                        opacity: 1,
                                                        color: "#141D43",
                                                        fontSize: "14px",
                                                      }}
                                                    />
                                                  ) : (
                                                    <Text marginTop={"10px"}>
                                                      {product
                                                        ?.certifiedMaterial
                                                        ?.lossPercent || "N/A"}
                                                    </Text>
                                                  )}
                                                </Box>
                                              </Box>
                                            </GridItem>
                                          </Grid>

                                          <Grid
                                            templateColumns="repeat(2,1fr)"
                                            gap="1rem"
                                            mt={"1rem"}
                                          >
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Consumption
                                              </Text>
                                              {TC?.status === "PENDING" &&
                                              TC?.stage === "CLIENT" ? (
                                                <Input
                                                  color={"#141D43"}
                                                  marginTop="10px"
                                                  border="2px solid  #8fd0fd !important"
                                                  w="100%"
                                                  bg={"#fff"}
                                                  fontSize={"14px"}
                                                  isDisabled
                                                  value={
                                                    product?.certifiedMaterial
                                                      ?.consumption
                                                  }
                                                  opacity={"1 !important"}
                                                  _placeholder={{
                                                    opacity: 1,
                                                    color: "#141D43",
                                                    fontSize: "14px",
                                                  }}
                                                />
                                              ) : (
                                                <Text marginTop={"10px"}>
                                                  {product?.certifiedMaterial
                                                    ?.consumption || "N/A"}
                                                </Text>
                                              )}
                                            </GridItem>
                                            <GridItem>
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                Certified Weight
                                              </Text>
                                              {TC?.status === "PENDING" &&
                                              TC?.stage === "CLIENT" ? (
                                                <Input
                                                  color={"#141D43"}
                                                  marginTop="10px"
                                                  border="2px solid  #8fd0fd !important"
                                                  w="100%"
                                                  bg={"#fff"}
                                                  isDisabled
                                                  value={
                                                    product?.certifiedMaterial
                                                      ?.certifiedWeight
                                                  }
                                                  opacity={"1 !important"}
                                                  fontSize={"14px"}
                                                  _placeholder={{
                                                    opacity: 1,
                                                    color: "#141D43",
                                                    fontSize: "14px",
                                                  }}
                                                />
                                              ) : (
                                                <Text marginTop={"10px"}>
                                                  {product?.certifiedMaterial
                                                    ?.certifiedWeight || "N/A"}
                                                </Text>
                                              )}
                                            </GridItem>
                                          </Grid>
                                          <Box
                                            marginTop="1rem"
                                            border={"1px solid #52BBFF"}
                                            width="100%"
                                            marginBottom={"1rem"}
                                          ></Box>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            marginTop={"1rem"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Non Certified Materials
                                          </Text>
                                          <Box
                                            border={"2px solid #2272D5"}
                                            width="10%"
                                            marginBottom={"1rem"}
                                          ></Box>
                                          <Accordion defaultIndex={[0]}>
                                            {product?.nonCertifiedMaterials?.map(
                                              (data, idx) => (
                                                <AccordionItem>
                                                  <h2>
                                                    <AccordionButton>
                                                      <Box
                                                        as="span"
                                                        flex="1"
                                                        textAlign="left"
                                                      >
                                                        <Text
                                                          color={"#141D43"}
                                                          fontSize="md"
                                                          fontWeight={"700"}
                                                          fontFamily={
                                                            "font.roboto"
                                                          }
                                                        >
                                                          {data?.nonCertifiedMaterialName
                                                            ? data?.nonCertifiedMaterialName
                                                            : "N/A"}
                                                        </Text>
                                                      </Box>
                                                      <AccordionIcon />
                                                    </AccordionButton>
                                                  </h2>
                                                  <AccordionPanel pb={4}>
                                                    <Box marginBottom={"1rem"}>
                                                      <Grid
                                                        templateColumns="repeat(2,2fr)"
                                                        gap="1rem"
                                                      >
                                                        <GridItem>
                                                          <Box>
                                                            <Text
                                                              color={"#141D43"}
                                                              fontSize="md"
                                                              fontWeight={"700"}
                                                              fontFamily={
                                                                "font.roboto"
                                                              }
                                                            >
                                                              Percentage
                                                            </Text>
                                                            {TC?.status ===
                                                              "PENDING" &&
                                                            TC?.stage ===
                                                              "CLIENT" ? (
                                                              <Input
                                                                color={
                                                                  "#141D43"
                                                                }
                                                                marginTop="10px"
                                                                border="2px solid  #8fd0fd !important"
                                                                w="100%"
                                                                type="number"
                                                                opacity={
                                                                  "1 !important"
                                                                }
                                                                name="percentage"
                                                                bg={"#fff"}
                                                                value={
                                                                  data?.percentage
                                                                }
                                                                onChange={(e) =>
                                                                  updateNcInput(
                                                                    index,
                                                                    idx,
                                                                    e
                                                                  )
                                                                }
                                                                fontSize={
                                                                  "14px"
                                                                }
                                                                _placeholder={{
                                                                  opacity: 1,
                                                                  color:
                                                                    "#141D43",
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                              />
                                                            ) : (
                                                              <Text
                                                                marginTop={
                                                                  "10px"
                                                                }
                                                              >
                                                                {data?.percentage ||
                                                                  "N/A"}
                                                              </Text>
                                                            )}
                                                          </Box>
                                                        </GridItem>
                                                        <GridItem>
                                                          <Box>
                                                            <Text
                                                              color={"#141D43"}
                                                              fontSize="md"
                                                              fontWeight={"700"}
                                                              fontFamily={
                                                                "font.roboto"
                                                              }
                                                            >
                                                              Loss Percent
                                                            </Text>
                                                            {TC?.status ===
                                                              "PENDING" &&
                                                            TC?.stage ===
                                                              "CLIENT" ? (
                                                              <Input
                                                                color="#141D43"
                                                                marginTop="10px"
                                                                border="2px solid #8fd0fd !important"
                                                                w="100%"
                                                                name="lossPercent"
                                                                opacity="1 !important"
                                                                bg="#fff"
                                                                value={
                                                                  data?.lossPercent
                                                                }
                                                                onChange={(e) =>
                                                                  updateNcInput(
                                                                    index,
                                                                    idx,
                                                                    e
                                                                  )
                                                                }
                                                                fontSize="14px"
                                                                _placeholder={{
                                                                  opacity: 1,
                                                                  color:
                                                                    "#141D43",
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                              />
                                                            ) : (
                                                              <Text marginTop="10px">
                                                                {data?.lossPercent ||
                                                                  "N/A"}
                                                              </Text>
                                                            )}
                                                          </Box>
                                                        </GridItem>
                                                      </Grid>
                                                      <Grid
                                                        templateColumns="repeat(2,1fr)"
                                                        gap="1rem"
                                                        mt={"1rem"}
                                                      >
                                                        <GridItem>
                                                          <Text
                                                            color={"#141D43"}
                                                            fontSize="md"
                                                            fontWeight={"700"}
                                                            fontFamily={
                                                              "font.roboto"
                                                            }
                                                          >
                                                            Consumption
                                                          </Text>
                                                          {TC?.status ===
                                                            "PENDING" &&
                                                          TC?.stage ===
                                                            "CLIENT" ? (
                                                            <Input
                                                              color="#141D43"
                                                              marginTop="10px"
                                                              border="2px solid #8fd0fd !important"
                                                              w="100%"
                                                              name="consumption"
                                                              opacity="1 !important"
                                                              bg="#fff"
                                                              value={
                                                                data?.consumption
                                                              }
                                                              onChange={(e) =>
                                                                updateNcInput(
                                                                  index,
                                                                  idx,
                                                                  e
                                                                )
                                                              }
                                                              fontSize="14px"
                                                              _placeholder={{
                                                                opacity: 1,
                                                                color:
                                                                  "#141D43",
                                                                fontSize:
                                                                  "14px",
                                                              }}
                                                            />
                                                          ) : (
                                                            <Text marginTop="10px">
                                                              {data?.consumption ||
                                                                "N/A"}
                                                            </Text>
                                                          )}
                                                        </GridItem>
                                                        <GridItem>
                                                          <Text
                                                            color={"#141D43"}
                                                            fontSize="md"
                                                            fontWeight={"700"}
                                                            fontFamily={
                                                              "font.roboto"
                                                            }
                                                          >
                                                            Certified Weight
                                                          </Text>
                                                          {TC?.status ===
                                                            "PENDING" &&
                                                          TC?.stage ===
                                                            "CLIENT" ? (
                                                            <Input
                                                              color={"#141D43"}
                                                              marginTop="10px"
                                                              border="2px solid  #8fd0fd !important"
                                                              w="100%"
                                                              bg={"#fff"}
                                                              value={
                                                                data?.nonCertifiedWeight
                                                              }
                                                              opacity={
                                                                "1 !important"
                                                              }
                                                              fontSize={"14px"}
                                                              _placeholder={{
                                                                opacity: 1,
                                                                color:
                                                                  "#141D43",
                                                                fontSize:
                                                                  "14px",
                                                              }}
                                                            />
                                                          ) : (
                                                            <Text marginTop="10px">
                                                              {data?.nonCertifiedWeight ||
                                                                "N/A"}
                                                            </Text>
                                                          )}
                                                        </GridItem>
                                                      </Grid>
                                                    </Box>
                                                  </AccordionPanel>
                                                </AccordionItem>
                                              )
                                            )}
                                          </Accordion>
                                        </GridItem>
                                      </Grid>
                                      <Grid
                                        templateColumns="repeat(1, 1fr)"
                                        mt="1rem"
                                      >
                                        <GridItem>
                                          <Text
                                            color={"#141D43"}
                                            fontSize="md"
                                            fontWeight={"700"}
                                            fontFamily={"font.roboto"}
                                          >
                                            Product Information
                                          </Text>
                                          {TC?.status === "PENDING" &&
                                          TC?.stage === "CLIENT" ? (
                                            <Textarea
                                              type="text"
                                              color={"#141D43"}
                                              marginTop="1rem"
                                              bg={"#fff"}
                                              h={"100%"}
                                              w={"100%"}
                                              opacity={"1 !important"}
                                              border="2px solid  #8fd0fd !important"
                                              value={
                                                product?.productInformation
                                              }
                                              onChange={(e) => {
                                                updateInput(
                                                  e.target.value,
                                                  "productInformation",
                                                  null,
                                                  index
                                                );
                                              }}
                                              fontSize={"14px"}
                                              _placeholder={{
                                                opacity: 1,
                                                color: " #464C64",
                                                fontSize: "14px",
                                              }}
                                            />
                                          ) : (
                                            <Text marginTop={"10px"}>
                                              {product?.productInformation ||
                                                "N/A"}
                                            </Text>
                                          )}
                                        </GridItem>
                                      </Grid>
                                    </Box>
                                  </Box>
                                </Box>
                              </GridItem>
                              <GridItem
                                borderLeft={{
                                  base: "",
                                  md: "",
                                  lg: "1px solid #52BBFF",
                                }}
                                paddingLeft={{
                                  base: "",
                                  md: "",
                                  lg: "0rem",
                                }}
                              >
                                <Box
                                  padding={"2rem"}
                                  marginTop="-4rem"
                                  borderRadius={"15px"}
                                >
                                  <Text
                                    color={"#141D43"}
                                    fontSize="md"
                                    fontWeight={"700"}
                                    marginTop={"4rem"}
                                    fontFamily={"font.roboto"}
                                  >
                                    List of Input Items
                                  </Text>
                                  <Box
                                    border={"2px solid #2272D5"}
                                    width="10%"
                                    marginBottom={"1rem"}
                                  ></Box>
                                  <Accordion defaultIndex={[0]}>
                                    {product?.inputs?.map((currentInput, idx) =>
                                      currentInput ? (
                                        <AccordionItem key={`input-${idx}`}>
                                          <AccordionButton>
                                            <Box
                                              as="span"
                                              flex="1"
                                              textAlign="left"
                                            >
                                              <Text
                                                color={"#141D43"}
                                                fontSize="md"
                                                fontWeight={"700"}
                                                fontFamily={"font.roboto"}
                                              >
                                                {currentInput?.inventoryName
                                                  ? currentInput.inventoryName
                                                  : "N/A"}
                                              </Text>
                                            </Box>
                                            <AccordionIcon />
                                          </AccordionButton>
                                          <AccordionPanel pb={4}>
                                            <Box marginBottom={"1rem"}>
                                              <Box
                                                display={"flex"}
                                                justifyContent="space-between"
                                                mt="1rem"
                                              >
                                                <Text
                                                  color={"#141D43"}
                                                  fontSize="lg"
                                                  fontWeight={"800"}
                                                >
                                                  <Box
                                                    as="span"
                                                    borderRight={
                                                      "3px solid #2272D5"
                                                    }
                                                    height="40px"
                                                    marginRight={"1rem"}
                                                  ></Box>
                                                  Input Details
                                                </Text>
                                              </Box>
                                              <Grid
                                                mt="1rem"
                                                templateColumns={
                                                  "repeat(1, 1fr)"
                                                }
                                              >
                                                <GridItem>
                                                  <Text
                                                    color={"#141D43"}
                                                    fontSize="md"
                                                    fontWeight={"700"}
                                                    fontFamily={"font.roboto"}
                                                  >
                                                    Inventory Details
                                                  </Text>
                                                  {TC?.status === "PENDING" &&
                                                  TC?.stage === "CLIENT" ? (
                                                    <Select
                                                      color={"#141D43"}
                                                      marginTop="10px"
                                                      border="2px solid  #8fd0fd !important"
                                                      w="100%"
                                                      value={
                                                        currentInput?.inventoryName
                                                      }
                                                      onChange={(e) => {
                                                        // updateInputInventory(
                                                        //   index,
                                                        //   idx,
                                                        //   e.target.value
                                                        // );
                                                        handleSelectChange(
                                                          index,
                                                          idx,
                                                          e.target.value
                                                        );
                                                        setInventoryId(
                                                          e.target.value
                                                        );
                                                      }}
                                                      name="inventoryDetails"
                                                      opacity={"1 !important"}
                                                      bg={"#fff"}
                                                      fontSize={"14px"}
                                                      _placeholder={{
                                                        opacity: 1,
                                                        color: "#141D43",
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                      <option hidden="true">
                                                        Select Inventory
                                                      </option>
                                                      {companyInventories?.map(
                                                        (inv) => (
                                                          <option
                                                            key={inv.id}
                                                            value={inv.id}
                                                          >
                                                            {inv.id} -{" "}
                                                            {inv?.type}
                                                          </option>
                                                        )
                                                      )}
                                                    </Select>
                                                  ) : (
                                                    <Text marginTop="10px">
                                                      {currentInput
                                                        ?.inventoryDetails
                                                        ?.id || "N/A"}
                                                    </Text>
                                                  )}
                                                </GridItem>
                                              </Grid>
                                              <Grid
                                                templateColumns="repeat(2, 1fr)"
                                                gap="1rem"
                                                mt="1rem"
                                              >
                                                <GridItem>
                                                  <Text
                                                    color={"#141D43"}
                                                    fontSize="md"
                                                    fontWeight={"700"}
                                                    fontFamily={"font.roboto"}
                                                  >
                                                    Available Quantity
                                                  </Text>
                                                  {TC?.status === "PENDING" &&
                                                  TC?.stage === "CLIENT" ? (
                                                    <Input
                                                      color={"#141D43"}
                                                      marginTop="10px"
                                                      border="2px solid  #8fd0fd !important"
                                                      w="100%"
                                                      bg={"#fff"}
                                                      value={
                                                        inventoryDetails?.remainingQuantity
                                                          ? inventoryDetails?.remainingQuantity
                                                          : currentInput?.availableQuantity
                                                      }
                                                      opacity={"1 !important"}
                                                      fontSize={"14px"}
                                                      _placeholder={{
                                                        opacity: 1,
                                                        color: "#141D43",
                                                        fontSize: "14px",
                                                      }}
                                                    />
                                                  ) : (
                                                    <Text marginTop="10px">
                                                      {currentInput?.availableQuantity ||
                                                        "N/A"}
                                                    </Text>
                                                  )}
                                                </GridItem>
                                                <GridItem>
                                                  <Text
                                                    color={"#141D43"}
                                                    fontSize="md"
                                                    fontWeight={"700"}
                                                    fontFamily={"font.roboto"}
                                                  >
                                                    Consumed Quantity
                                                  </Text>
                                                  {TC?.status === "PENDING" &&
                                                  TC?.stage === "CLIENT" ? (
                                                    <Input
                                                      color={"#141D43"}
                                                      marginTop="10px"
                                                      type="number"
                                                      name="consumedQuantity"
                                                      border="2px solid  #8fd0fd !important"
                                                      w="100%"
                                                      opacity={"1 !important"}
                                                      bg={"#fff"}
                                                      value={
                                                        currentInput?.consumedQuantity
                                                      }
                                                      onChange={(e) =>
                                                        updateInputItem(
                                                          index,
                                                          idx,
                                                          e
                                                        )
                                                      }
                                                      fontSize={"14px"}
                                                      _placeholder={{
                                                        opacity: 1,
                                                        color: "#141D43",
                                                        fontSize: "14px",
                                                      }}
                                                    />
                                                  ) : (
                                                    <Text marginTop="10px">
                                                      {currentInput?.consumedQuantity ||
                                                        "N/A"}
                                                    </Text>
                                                  )}
                                                </GridItem>
                                              </Grid>
                                            </Box>
                                          </AccordionPanel>
                                        </AccordionItem>
                                      ) : (
                                        <Text
                                          fontSize="md"
                                          fontWeight={"700"}
                                          marginTop={"1rem"}
                                          fontFamily={"font.roboto"}
                                        >
                                          N/A
                                        </Text>
                                      )
                                    )}
                                  </Accordion>
                                </Box>
                              </GridItem>
                            </Grid>
                          </Box>
                        </AccordionPanel>
                      </AccordionItem>
                    ))
                  ) : (
                    <Text
                      fontSize="md"
                      fontWeight={"700"}
                      marginTop={"1rem"}
                      fontFamily={"font.roboto"}
                    >
                      N/A
                    </Text>
                  )}
                </Accordion>
              </Box>
            </GridItem>
          </Grid>
        </Box>

        <Box
          bg="#FFFFFF"
          padding={"2rem"}
          marginTop="2rem"
          borderRadius={"15px"}
        >
          <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
            Total Weight Details
          </Text>
          <Box
            border={"2px solid #2272D5"}
            width="15%"
            marginBottom={"1rem"}
            mt="1rem"
          ></Box>
          <Box paddingLeft={"3rem"}>
            <Box>
              <Grid
                alignItems={"flex-end"}
                gap={"3rem"}
                templateColumns="repeat(1, 1fr)"
                marginTop={"1rem"}
              >
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent={"center"}
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(5, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Net Weight(kg)
                      </Text>
                      <Text marginTop="10px" fontSize="14px" color="#464C64">
                        {totalNetWeight}
                      </Text>
                    </GridItem>
                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Gross Weight(kg)
                      </Text>
                      <Text marginTop="10px" fontSize="14px" color="#464C64">
                        {totalGrossWeight}
                      </Text>
                    </GridItem>

                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Certified Weight(kg)
                      </Text>
                      <Text marginTop="10px" fontSize="14px" color="#464C64">
                        {totalCertifiedWeight}
                      </Text>
                    </GridItem>
                  </Grid>
                </Box>
              </Grid>
            </Box>
          </Box>
        </Box>
        {/* document section */}
        <Box bg="#FFFFFF" p={"1rem"} marginTop="2rem" borderRadius={"15px"}>
          <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
            Supporting Documents
          </Text>
          <Box
            border={"2px solid #2272D5"}
            width="15%"
            marginBottom={"1rem"}
            mt="1rem"
          ></Box>
          <Box paddingLeft={"3rem"}>
            <Box>
              <Grid width={"100%"} templateColumns="repeat(4, 1fr)" gap="3rem">
                <DocumentViewer
                  document={TC?.tc_invoiceDocuments}
                  referenceId={TC?._id}
                  doc_from={DOCUMENT_FROM.TC}
                />
                <DocumentViewer
                  document={TC?.tc_transportDocuments}
                  referenceId={TC?._id}
                  doc_from={DOCUMENT_FROM.TC}
                />
                <DocumentViewer
                  document={TC?.tc_documents}
                  referenceId={TC?._id}
                  doc_from={DOCUMENT_FROM.TC}
                />
              </Grid>
            </Box>
          </Box>
          <Grid width={"100%"} templateColumns="repeat(4, 1fr)" gap="3rem">
            <Input
              value={tcData?.invoiceDocName || ""}
              onChange={(e) =>
                handleDocumentChange("invoiceDocName", e.target.value)
              }
              isDisabled={
                TC?.status === "PENDING" && TC?.stage === "CLIENT"
                  ? false
                  : true
              }
            />

            <Input
              value={tcData?.transportDocName || ""}
              onChange={(e) =>
                handleDocumentChange("transportDocName", e.target.value)
              }
              isDisabled={
                TC?.status === "PENDING" && TC?.stage === "CLIENT"
                  ? false
                  : true
              }
            />

            <Input
              value={tcData?.documentsName || ""}
              onChange={(e) =>
                handleDocumentChange("documentsName", e.target.value)
              }
              isDisabled={
                TC?.status === "PENDING" && TC?.stage === "CLIENT"
                  ? false
                  : true
              }
            />
          </Grid>
        </Box>
        {TC?.status === "PENDING" && TC?.stage === "CLIENT" ? (
          <>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                Update Supporting Documents
              </Text>
              <Box marginTop="2rem" borderRadius={"15px"}>
                <Grid
                  width={"100%"}
                  mt={"3rem"}
                  mb={"2rem"}
                  gap="3rem"
                  height={"100%"}
                  templateColumns="repeat(3, 1fr)"
                >
                  <GridItem>
                    <Button
                      bg="#FFFFFF"
                      color={"black"}
                      width={"270"}
                      height={"175"}
                      leftIcon={<FiUpload />}
                      borderRadius={"15px"}
                      as="label"
                      htmlFor="file-upload-invoice"
                      variant="outline"
                    >
                      Upload Invoice Document
                      <VisuallyHidden>
                        <input
                          id="file-upload-invoice"
                          type="file"
                          onChange={handleInvoiceFileChange}
                        />
                      </VisuallyHidden>
                    </Button>
                  </GridItem>

                  <GridItem>
                    <Button
                      bg="#FFFFFF"
                      color={"#000000"}
                      width={"270"}
                      height={"175"}
                      leftIcon={<FiUpload />}
                      borderRadius={"15px"}
                      as="label"
                      htmlFor="file-upload-transport"
                      variant="outline"
                    >
                      Upload Transport Document
                      <VisuallyHidden>
                        <input
                          id="file-upload-transport"
                          type="file"
                          onChange={handleTransportFileChange}
                        />
                      </VisuallyHidden>
                    </Button>
                  </GridItem>

                  <GridItem>
                    <Button
                      bg="#FFFFFF"
                      color={"black"}
                      width={"270"}
                      height={"175"}
                      leftIcon={<FiUpload />}
                      borderRadius={"15px"}
                      as="label"
                      htmlFor="file-upload-document"
                      variant="outline"
                    >
                      Upload other Document
                      <VisuallyHidden>
                        <input
                          id="file-upload-document"
                          type="file"
                          onChange={handleDocumentFileChange}
                        />
                      </VisuallyHidden>
                    </Button>
                  </GridItem>
                </Grid>
                <Grid templateColumns="repeat(3, 1fr)" gap="3rem" mb="2rem">
                  <GridItem>
                    {invoiceFile && (
                      <GridItem colSpan={1}>
                        <Box display={"flex"} className="overflow-style">
                          <>
                            <Box
                              bg="#FFFFFF"
                              w={"270px"}
                              h={"175px"}
                              borderRadius={"15px"}
                              boxShadow={
                                "rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"
                              }
                            >
                              <Box display={"flex"} justifyContent={"right"}>
                                <Button
                                  borderColor="#FFFFFF"
                                  bg="#ffffff"
                                  size="sm"
                                  variant="outline"
                                  onClick={() => setInvoiceFile()}
                                  leftIcon={<RemoveIcon />}
                                ></Button>
                              </Box>
                              <Box display={"flex"} justifyContent={"center"}>
                                <FileIcon />
                              </Box>
                              <Tooltip label={invoiceFile?.name}>
                                <Text
                                  margin={"auto"}
                                  width={"130px"}
                                  whiteSpace={"nowrap"}
                                  overflow={"hidden"}
                                  textOverflow={"ellipsis"}
                                >
                                  {invoiceFile?.name}
                                </Text>
                              </Tooltip>
                            </Box>
                          </>
                        </Box>
                      </GridItem>
                    )}
                  </GridItem>
                  <GridItem>
                    {transportFile && (
                      <GridItem colSpan={1}>
                        <Box display={"flex"} className="overflow-style">
                          <>
                            <Box
                              bg="#FFFFFF"
                              w={"270px"}
                              h={"175px"}
                              borderRadius={"15px"}
                              boxShadow={
                                "rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"
                              }
                            >
                              <Box display={"flex"} justifyContent={"right"}>
                                <Button
                                  borderColor="#FFFFFF"
                                  bg="#ffffff"
                                  size="sm"
                                  variant="outline"
                                  onClick={() => setTransportFile()}
                                  leftIcon={<RemoveIcon />}
                                ></Button>
                              </Box>
                              <Box display={"flex"} justifyContent={"center"}>
                                <FileIcon />
                              </Box>
                              <Tooltip label={transportFile?.name}>
                                <Text
                                  width={"130px"}
                                  margin={"auto"}
                                  whiteSpace={"nowrap"}
                                  overflow={"hidden"}
                                  textOverflow={"ellipsis"}
                                >
                                  {transportFile?.name}
                                </Text>
                              </Tooltip>
                            </Box>
                          </>
                        </Box>
                      </GridItem>
                    )}
                  </GridItem>
                  <GridItem>
                    {documentFile && (
                      <GridItem colSpan={1}>
                        <Box display={"flex"} className="overflow-style">
                          <>
                            <Box
                              bg="#FFFFFF"
                              w={"270px"}
                              h={"175px"}
                              borderRadius={"15px"}
                              textAlign={"center"}
                              boxShadow={
                                "rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"
                              }
                            >
                              <Box display={"flex"} justifyContent={"right"}>
                                <Button
                                  borderColor="#FFFFFF"
                                  bg="#ffffff"
                                  size="sm"
                                  variant="outline"
                                  onClick={() => setDocumentFile()}
                                  leftIcon={<RemoveIcon />}
                                ></Button>
                              </Box>
                              <Box display={"flex"} justifyContent={"center"}>
                                <FileIcon />
                              </Box>
                              <Tooltip label={documentFile?.name}>
                                <Text
                                  width={"130px"}
                                  margin={"auto"}
                                  whiteSpace={"nowrap"}
                                  overflow={"hidden"}
                                  textOverflow={"ellipsis"}
                                >
                                  {documentFile?.name}
                                </Text>
                              </Tooltip>
                            </Box>
                          </>
                        </Box>
                      </GridItem>
                    )}
                  </GridItem>
                </Grid>
              </Box>
            </Box>
            <Box mt="1rem" display={"flex"} justifyContent={"center"}>
              {errorMessage && (
                <Box
                  bg="crimson"
                  color="white"
                  p="1rem"
                  borderRadius="15px"
                  mb="1rem"
                  w="60%"
                  textAlign={"center"}
                >
                  {errorMessage}
                  <Button
                    size="sm"
                    variant="outline"
                    ml="1rem"
                    bg="white"
                    color="black"
                    onClick={clearErrorMessage}
                  >
                    <RemoveIcon />
                  </Button>
                </Box>
              )}
            </Box>
          </>
        ) : (
          <></>
        )}
        <Box bg="#FFFFFF" p={"1rem"} marginTop="2rem" borderRadius={"15px"}>
          <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
            Remarks
          </Text>
          <Box
            border={"2px solid #2272D5"}
            width="15%"
            marginBottom={"1rem"}
            mt="1rem"
          ></Box>

          <TableContainer className="overflow-style" marginTop={"1rem"}>
            <Table
              variant={"simple"}
              size="md"
              bg={"#fff"}
              borderRadius={"15px"}
              pr={"1rem"}
            >
              <Thead>
                <Tr>
                  <Th color="brand.blue" textTransform="capitalize">
                    Sr no.
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Date Time
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Remarks
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {remarks?.length > 0 ? (
                  remarks?.map((remark, index) => {
                    return (
                      <Tr>
                        <Td>{index + 1}</Td>
                        <Td>{`${moment(remark?.time).format(
                          "DD-MM-YYYY hh:mm"
                        )}`}</Td>
                        <Td>{remark?.comment ? remark?.comment : "N/A"}</Td>
                      </Tr>
                    );
                  })
                ) : (
                  <Box marginTop={"1rem"} fontWeight={"700"}>
                    <Text marginTop={"1rem"} fontWeight={"700"} ml="100%">
                      No Comments Yet
                    </Text>
                  </Box>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
        <Box mt={"4rem"} paddingBottom={"2rem"}>
          {editable == 2 &&
            TC?.stage === "CLIENT" &&
            TC?.status === "PENDING" && (
              <ButtonGroup gap={2}>
                <Button
                  bg="#52BBFF"
                  type="submit"
                  onClick={handleUpdateTc}
                  color={"#ffffFF"}
                  _hover={{ bg: "#52BBFF" }}
                  w="193px"
                  h="50px"
                  disabled={isLoading ? true : false}
                >
                  Update TC
                </Button>
              </ButtonGroup>
            )}
        </Box>
      </Box>

      <Flex gap={4} mb="2rem" mt="2rem">
        {TC?.shipmentStatus === "INCOMING" &&
        userData?.companyId === TC?.buyerId ? (
          <Box paddingBottom={"2rem"} marginBottom={"4rem"}>
            <ButtonGroup gap={2} mt="1rem">
              <Button
                bg="#52BBFF"
                color={"#ffffFF"}
                _hover={{ bg: "#52BBFF" }}
                w="193px"
                h="50px"
                disabled={isLoading ? true : false}
                // onClick={() => approveAction()}
                onClick={() => setIsOpenMod(true)}
              >
                Accept
              </Button>

              <Button
                bg="crimson"
                color={"#ffffFF"}
                _hover={{ bg: "crimson" }}
                w="193px"
                h="50px"
                disabled={isLoading ? true : false}
                // onClick={() => rejectAction()}
                onClick={() => setIsOpen(true)}
              >
                Reject
              </Button>
            </ButtonGroup>
          </Box>
        ) : (
          ""
        )}

        {TC?.shipmentStatus === "PENDING" ||
        (TC?.status === "PENDING" && TC?.stage === "CLIENT") ? (
          <></>
        ) : (
          <>
            <Button
              as={Link}
              bg="#A8BF87"
              color={"#ffffff"}
              _hover={{ bg: "#A8BF87" }}
              w="193px"
              h="50px"
              mt="1rem"
              onClick={() => setShowPreview((prev) => !prev)}
            >
              {!showPreview ? (
                <>
                  View TC &nbsp; <AiOutlineEye size={24} />
                </>
              ) : (
                <>
                  Hide View &nbsp; <AiOutlineEyeInvisible size={24} />
                </>
              )}
            </Button>
          </>
        )}
      </Flex>
      {showPreview ? (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Spinner width="50px" height="50px" color="#3958DC" />
              <Text marginLeft="10px">Loading the TC...</Text>
            </Box>
          }
        >
          <Box marginTop={"1rem"} marginBottom="1rem">
            <TCnew
              tcData={TC}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isPreview={TC?.status !== "APPROVE"}
            />
          </Box>
        </Suspense>
      ) : (
        ""
      )}

      <CustomAlertDialog
        isOpen={isOpen}
        onClose={onClose}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="red"
        onConfirm={() => rejectAction()}
      />
      <CustomAlertDialog
        isOpen={isOpenMod}
        onClose={onCloseMod}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="#52BBFF"
        onConfirm={() => approveAction()}
      />
    </>
  );
};

export default isAllowed(ClientTCDetails);
